import axios from "./axios"

const getSubscriptions = async (page = 1, perPage = 20, filters = {}) => {
  try {
    const params = {
      page,
      per_page: perPage,
      ...filters,
    }
    return await axios.get("/admin/subscriptions", { params })
  } catch (error) {
    throw error
  }
}

const getSubscriptionCounts = async (filters = {}) => {
  try {
    const params = { ...filters }
    return await axios.get("/admin/subscriptions/counts", { params })
  } catch (error) {
    throw error
  }
}

const getSubscriptionByUserId = async (userId) => {
  try {
    return await axios.get(`/admin/subscriptions/user/${userId}`)
  } catch (error) {
    throw error
  }
}

export default {
  getSubscriptions,
  getSubscriptionCounts,
  getSubscriptionByUserId,
}
